/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raffle_Pool_No_Game_WinInputs */



/**
* | output |
* | --- |
* | "No game win" |
*
* @param {Raffle_Pool_No_Game_WinInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const raffle_pool_no_game_win = /** @type {((inputs?: Raffle_Pool_No_Game_WinInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raffle_Pool_No_Game_WinInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sans victoire de partie")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sin victoria de partida")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Sem vitória de partida")
	if (locale === "it") return /** @type {LocalizedString} */ ("Senza vittoria di partita")
	return /** @type {LocalizedString} */ ("No game win")
});